import { compareAsc, startOfDay } from 'date-fns';

const isDateInPast = (date: Date) => {
  return compareAsc(startOfDay(new Date()), startOfDay(date)) === 1;
};

export default isDateInPast;
